import { AnyAction } from 'redux';

export const RESOURCE_MISSING = 'RESOURCE_MISSING';
export const RESOURCE_MISSING_RESET = 'RESOURCE_MISSING_RESET';

/** The record behind the address does not exist. */
export const resourceMissing = () => ({ type: RESOURCE_MISSING });

/** Cleared on the way to the next address, before anything is fetched. */
export const resetResourceMissing = () => ({ type: RESOURCE_MISSING_RESET });

export type ResourceMissingReducerState = boolean;

export const resourceMissingReducer = (state: ResourceMissingReducerState = false, action: AnyAction): boolean => {
    switch (action.type) {
        case RESOURCE_MISSING:
            return true;
        case RESOURCE_MISSING_RESET:
            return false;
        default:
            return state;
    }
};
